import { render, staticRenderFns } from "./ShelfOperations.vue?vue&type=template&id=50b4fb70&scoped=true&"
import script from "./ShelfOperations.vue?vue&type=script&lang=js&"
export * from "./ShelfOperations.vue?vue&type=script&lang=js&"
import style0 from "./ShelfOperations.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShelfOperations.vue?vue&type=style&index=1&id=50b4fb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4fb70",
  null
  
)

export default component.exports